import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  fetchCalendarExceptions,
  createCalendarException,
  updateCalendarException,
  deleteCalendarException,
  bulkUpsertCalendarExceptions
} from "../fetchers/calendarExceptions";

export function useCalendarExceptions(companyKey, from, to) {
  return useQuery({
    queryKey: ["calendarExceptions", companyKey, from, to],
    queryFn: () => fetchCalendarExceptions(companyKey, from, to),
    enabled: !!companyKey && !!from && !!to,
    staleTime: 60_000,
  });
}

export function useCreateCalendarException(companyKey, from, to) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload) => createCalendarException(companyKey, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["calendarExceptions", companyKey, from, to] }),
  });
}

export function useUpdateCalendarException(companyKey, from, to) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, payload }) => updateCalendarException(id, payload),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["calendarExceptions", companyKey, from, to] }),
  });
}

export function useDeleteCalendarException(companyKey, from, to) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => deleteCalendarException(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["calendarExceptions", companyKey, from, to] }),
  });
}

export function useBulkUpsertCalendarExceptions(companyKey, from, to) {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async (items) => bulkUpsertCalendarExceptions(companyKey, items),
    onSuccess: async () => {
      // uppdatera listan i fliken + matrisen
      await qc.invalidateQueries({ queryKey: ["calendarExceptions", companyKey, from, to] });
      await qc.invalidateQueries({ queryKey: ["calendarMatrix", companyKey], exact: false });
    },
  });
}
